export { getTotalStepsForIndicator } from './getTotalSteps';
export { getStepNumberForIndicator } from './getStepNumber';
